
import styles from './styles.module.scss';

import cn from 'classnames';
import Button from '../../../Buttons/Button';


export default function PaginationPageButton({
  isActive = false,
  isShow = true,
  onClick = () => { },
  children,
  ...props
}) {
  return (
    <Button
      className={cn(styles.circle_button, !isShow && styles.display_none, isActive && styles.circle_button_active)}
      onClick={() => onClick()}
    >
      {children}
    </Button>
  );
}
